/**
 * 资源分析服务服务实现类
 */
const IResourceAnalysisService = require('../IResourceAnalysisService');
const SqlParserUtil = require('./common/SqlParserUtil');
const Util = require('./common/Util');
const ResourceAnalysisUtil = require('./common/ResourceAnalysisUtil');
const extend = require('../../../base/util/Extend');
/**
 * @classdesc 资源分析服务
 * @alias G.servicev2.ResourceAnalysisServiceImpl
 * @augments G.service.IResourceAnalysisService
 * @param opts
 * @param opts.httpRequest {G.base.IHttpRequest} 请求对象
 * @param opts.url {String} 服务地址
 * @param opts.configUrl {String} 资源配置URL，格式参考示例中  html/serivce/analysisresource.json ；
 * 对应不同事件类型的配置，url中可用eventType动态参数，如 "http://.../{eventType}.json" 
 * 或者 "http://.../analysisresource.json?eventType={eventType}"
 */
class ResourceAnalysisServiceImpl extends IResourceAnalysisService {
    constructor(opts) {
        super(opts);
        //
    }

    /**
     * 获取分析的资源目录结构
     * @inheritdoc
     */
    getResourceCatalog(opts) {
        return new Promise(async(resolve, reject) => {
            let catalog = await ResourceAnalysisUtil.getResourceCatalog(
                this.opts.httpRequest,
                this.opts.configUrl,
                this.opts.url,
                opts.eventType);
            resolve(catalog);
        });
    }

    /**
     * 缓冲查询
     * @inheritdoc
     */
    bufferQuery(opts) {
        return new Promise(async(resolve, reject) => {
            let options = extend(true, {}, opts);
            options.resources = options.resources || [];
            options.spatialReference = options.spatialReference || 4326;
            if (Object.prototype.toString.call(options.radius) == '[object Number]') {
                options.radius = [opts.radius];
            }
            await this._ensureResourceTree(opts.eventType);
            let aggregateList = ResourceAnalysisUtil.makeBufferAggregates(options);
            let queryReuslt = await Util.aggregateMulti({
                url: this.opts.url,
                httpRequest: this.opts.httpRequest,
                aggregateList: aggregateList
            });
            let result = ResourceAnalysisUtil.parseBufferQueryResult(queryReuslt, options.radius, options.resources);
            resolve(result);
        });
    }


    /**
     * 自定义范围查询
     * @inheritdoc
     */
    polygonQuery(opts) {
        return new Promise(async(resolve, reject) => {
            let options = extend(true, {}, opts);
            options.resources = options.resources || [];
            options.spatialReference = options.spatialReference || 4326;
            await this._ensureResourceTree(opts.eventType);
            let aggregateList = ResourceAnalysisUtil.makeAggregates(options, 'polygon');
            let queryReuslt = await Util.aggregateMulti({
                url: this.opts.url,
                httpRequest: this.opts.httpRequest,
                aggregateList: aggregateList
            });
            let result = ResourceAnalysisUtil.parseQueryResult(queryReuslt, options.resources);
            resolve(result);
        });
    }

    /**
     * 关键字查询
     * @inheritdoc
     */
    keywordQuery(opts) {
        return new Promise(async(resolve, reject) => {
            let options = extend(true, {}, opts);
            options.resources = options.resources || [];
            options.spatialReference = options.spatialReference || 4326;
            await this._ensureResourceTree(opts.eventType);
            let aggregateList = ResourceAnalysisUtil.makeAggregates(options, 'keyword');
            let queryReuslt = await Util.aggregateMulti({
                url: this.opts.url,
                httpRequest: this.opts.httpRequest,
                aggregateList: aggregateList
            });
            let result = ResourceAnalysisUtil.parseQueryResult(queryReuslt, options.resources);
            resolve(result);
        });
    }

    /**
     * 行政区划查询
     * @inheritdoc
     */
    districtQuery(opts) {
        return new Promise(async(resolve, reject) => {
            let options = extend(true, {}, opts);
            options.resources = options.resources || [];
            options.spatialReference = options.spatialReference || 4326;
            await this._ensureResourceTree(opts.eventType);
            let aggregateList = ResourceAnalysisUtil.makeAggregates(options, 'district');
            let queryReuslt = await Util.aggregateMulti({
                url: this.opts.url,
                httpRequest: this.opts.httpRequest,
                aggregateList: aggregateList
            });
            let result = ResourceAnalysisUtil.parseQueryResult(queryReuslt, options.resources);
            resolve(result);
        });
    }

    //
    _ensureResourceTree(eventType) {
        return new Promise(async(resolve, reject) => {
            if (eventType != undefined && eventType != null) {
                await ResourceAnalysisUtil.getResourceCatalog(
                    this.opts.httpRequest,
                    this.opts.configUrl,
                    this.opts.url,
                    eventType);
            }
            resolve();
        });
    }


    /**
     * 缓冲区统计
     * @inheritdoc
     */
    bufferStatistics(opts) {
        //todo
        console.warn('敬请期待……')
    }

    /**
     * 自定义范围统计
     * @inheritdoc
     */
    polygonStatistics(opts) {
        //todo
        console.warn('敬请期待……')
    }

    /**
     * 关键字统计
     * @inheritdoc
     */
    keywordStatistics(opts) {
        //todo
        console.warn('敬请期待……')
    }


    /**
     * 行政区划统计
     * @inheritdoc
     */
    districtStatistics(opts) {
        //todo
        console.warn('敬请期待……')
    }

    /**
     * @description 根据资源ID获取资源配置
     * @param {String} resourceId 
     */
    getResourceConfig(resourceId) {
        return ResourceAnalysisUtil.getResourceConfigById(resourceId);
    }

    /**
     * 销毁
     */
    destroy() {
        ResourceAnalysisUtil.clear();
    }
}
module.exports = ResourceAnalysisServiceImpl;